// extracted by mini-css-extract-plugin
module.exports = {"reported-treatments":"reported-treatments___1i-G8","treatment-title":"treatment-title___1GGAd","treatment-line":"treatment-line___3-h5t"};